import { GET_VERSION_LIST, SAVE_VERSION_LIST } from "../types/action-type";

const initialState = {
  versionList: [],
  loading: false,
  error: null,
};

export default function versionReducer(state = initialState, action) {
  switch (action.type) {

    case GET_VERSION_LIST:
      return {
        ...state,
        loading: true,
      };

    case SAVE_VERSION_LIST:
      return {
        ...state,
        loading: false,
        versionList: action.data,   // 👈 the correct data from API
      };

    default:
      return state;
  }
}
